/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-primary[_ngcontent-%COMP%]{border:0}a.log-out[_ngcontent-%COMP%]{line-height:55px;color:#fff;text-decoration:none;margin-left:15px;display:block;width:5.5em}[_nghost-%COMP%]{width:5.8em}"];
export { styles as styles };
